import type APIAddress from '~/types/APIAddress';

import { type BaseAddress } from '~/types/Address';
import { type TrackingReference } from '~/utils/TrackingHelper/types';

import { ActionKeys } from './constants';

interface ManualOrderAddresses {
  recipient?: BaseAddress; // @TODO type
  return?: APIAddress; // type here
  sender?: APIAddress; // type here
}

interface ManualOrderConditionals {
  bypassAddressValidation?: boolean;
  saveAsDefaultReturnAddress: boolean;
  saveAsDefaultSenderAddress: boolean;
  useSenderAddressAsReturn: boolean;
}

export interface ManualOrder {
  addresses: ManualOrderAddresses;
  conditionals: ManualOrderConditionals;
}

export const createOrder = (manualOrder: ManualOrder, trackingReference: TrackingReference) =>
  <const>{
    payload: {
      manualOrder,
      trackingReference,
    },
    type: ActionKeys.MANUALORDER_SAVE_ORDER,
  };

export const createOrderSuccess = (objectId: string) =>
  <const>{
    payload: {
      objectId,
    },
    type: ActionKeys.MANUALORDER_SAVE_ORDER_SUCCESS,
  };

export const createOrderError = (message: string, error: Error) =>
  <const>{
    payload: {
      error,
      message,
    },
    type: ActionKeys.MANUALORDER_SAVE_ORDER_FAILURE,
  };

export const clearError = () =>
  <const>{
    type: ActionKeys.MANUALORDER_CLEAR_ERROR_MESSAGE,
  };

export const manualOrderReset = () =>
  <const>{
    type: ActionKeys.MANUALORDER_RESET,
  };

export type ManualOrderActions =
  | ReturnType<typeof clearError>
  | ReturnType<typeof createOrder>
  | ReturnType<typeof createOrderError>
  | ReturnType<typeof createOrderSuccess>
  | ReturnType<typeof manualOrderReset>;
